export const MAX_UINT64_VALUE = (1n << 64n) - 1n;
export const SIZEOF_INT64 = 8;
